"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasUndo = void 0;
function hasUndo(game) {
    return typeof game.canUndo === 'function';
}
exports.hasUndo = hasUndo;
